import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import Chat from "./Chat";
import Edds from "./Edds";
import StreamAwards from "./Streamawards";
import TTS from "./TTS";
import FilowTTS from "./FilowTTS";
import reportWebVitals from "./reportWebVitals";

import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import Overlay from "./Overlay";

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <Route path="/" exact component={App} />
      <Route path="/chat/:list" exact component={Chat} />
      <Route path="/edds/:list" exact component={Edds} />
      <Route path="/overlay/:list" component={Overlay} />
      <Route path="/revedtts" component={TTS} />
      <Route path="/filowtts" component={FilowTTS} />
      <Route path="/streamawards/:width" component={StreamAwards} />
    </Router>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
